import React, { useEffect } from "react";
import '../Pages/About.css';
import SEO from "../Components/SEO";
import { FaHistory, FaBullseye, FaEye, FaAward, FaUserTie, FaUsers } from "react-icons/fa";
import AOS from "aos";
import 'aos/dist/aos.css';

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="about-page">
      <SEO 
        title="About Us" 
        description="Learn about Vark Builders, the top construction company in Madurai. Our history, mission, vision, and commitment to excellence in civil engineering."
      />
      
      <div className="about-banner">
        <div className="container" data-aos="fade-up">
          <h1>Building Legacies, <span>Designing Dreams</span></h1>
          <p>Over two decades of excellence in construction and engineering across Tamil Nadu.</p>
        </div>
      </div>

      <section className="about-intro">
        <div className="container">
          <div className="intro-content" data-aos="fade-up">
            <div className="intro-text">
              <h2>Who We <span>Are</span></h2>
              <p>
                Vark Builders is a premier construction company based in Madurai, dedicated to delivering 
                high-quality residential and commercial projects. With a team of experienced civil engineers, 
                modern architects, and skilled artisans, we have successfully completed over 400 projects.
              </p>
              <p>
                Our philosophy is built on three pillars: <strong>Precision, Transparency, and Durability</strong>. 
                Whether it's a luxury villa or a large-scale commercial complex, we bring the same level of 
                dedication and technical expertise to every square foot we build.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="vision-mission">
        <div className="container">
          <div className="vm-grid">
            <div className="vm-card" data-aos="fade-right">
              <FaBullseye className="vm-icon" />
              <h3>Our <span>Mission</span></h3>
              <p>To provide budget-friendly, high-quality construction services while maintaining the highest standards of safety and professional integrity.</p>
            </div>
            <div className="vm-card" data-aos="fade-left">
              <FaEye className="vm-icon" />
              <h3>Our <span>Vision</span></h3>
              <p>To be the most reliable building promoters in Tamil Nadu, recognized for our innovative designs and sustainable construction practices.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-accent">
        <div className="container">
          <div className="accent-grid">
            <div className="accent-item" data-aos="zoom-in">
              <FaAward />
              <h4>20+ Years</h4>
              <p>Excellence</p>
            </div>
            <div className="accent-item" data-aos="zoom-in" data-aos-delay="100">
              <FaUserTie />
              <h4>25+ Expert</h4>
              <p>Engineers</p>
            </div>
            <div className="accent-item" data-aos="zoom-in" data-aos-delay="200">
              <FaUsers />
              <h4>390+ Happy</h4>
              <p>Families</p>
            </div>
          </div>
        </div>
      </section>

      <section className="why-us-minimal">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <h2>Why Partners <span>Choose Us</span></h2>
          </div>
          <div className="minimal-grid">
            <div className="min-card" data-aos="fade-up">
              <FaHistory />
              <h4>Proven Track Record</h4>
              <p>Consistent delivery of complex projects with structural reliability.</p>
            </div>
            {/* Add more cards if needed */}
          </div>
        </div>
      </section>
    </div>
  );
}
